/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dialog_Delete_Folder_And_FilesInputs */

const en_dialog_delete_folder_and_files = /** @type {(inputs: Dialog_Delete_Folder_And_FilesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Delete folder and remove ${i?.count} file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Delete folder and remove ${i?.count} files`);
	return /** @type {LocalizedString} */ ("dialog_delete_folder_and_files");
};

const es_dialog_delete_folder_and_files = /** @type {(inputs: Dialog_Delete_Folder_And_FilesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Eliminar carpeta y quitar ${i?.count} archivo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Eliminar carpeta y quitar ${i?.count} archivos`);
	return /** @type {LocalizedString} */ ("dialog_delete_folder_and_files");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Delete folder and remove {count} file" |
* | "other" | "Delete folder and remove {count} files" |
*
* @param {Dialog_Delete_Folder_And_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_delete_folder_and_files = /** @type {((inputs: Dialog_Delete_Folder_And_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delete_Folder_And_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_delete_folder_and_files(inputs)
	return en_dialog_delete_folder_and_files(inputs)
});